/* Preview media using Organic's existing gallery, thumbnails and zoom components.
   No Shopify product record is modified. Source: product-gallery/gallery-manifest.json. */
(() => {
 async function init() {
  const element=document.querySelector('[data-diy-gallery-config]');
  if(!element)return;
  const config=JSON.parse(element.textContent);
  const concept=Number(new URLSearchParams(location.search).get('diy_concept'));
  const conceptFile=Number.isInteger(concept)&&concept>=1&&concept<=3?config.concepts?.[concept-1]:null;
  await customElements.whenDefined('media-gallery');
  const galleries=[...document.querySelectorAll('media-gallery')];
  const modal=document.querySelector('product-modal .product-media-modal__content');
  const modalTemplate=modal?.querySelector('img[data-media-id]')?.cloneNode(true);
  const replaceIds=(node,oldId,newId)=>{
   for(const el of [node,...node.querySelectorAll('*')])
    for(const attr of [...el.attributes])
     if(attr.value.includes(oldId))el.setAttribute(attr.name,attr.value.replaceAll(oldId,newId));
  };
  const paint=(node,file)=>{
   for(const image of node.matches?.('img')?[node]:node.querySelectorAll('img')){
    image.src=file.url;image.removeAttribute('srcset');image.removeAttribute('sizes');
    image.width=1400;image.height=1400;image.alt=file.alt;image.loading='eager';
   }
   for(const el of node.querySelectorAll('[style*="--ratio"]')){
    el.style.setProperty('--ratio','1');el.style.setProperty('--preview-ratio','1');
   }
  };
  for(const gallery of galleries){
   const viewer=gallery.querySelector('[id^="Slider-Gallery-"]');
   const thumbs=gallery.querySelector('[id^="Slider-Thumbnails-"]');
   if(!viewer||!thumbs)continue;
   const templates=[...viewer.children].filter(el=>el.dataset.mediaId).map(el=>el.cloneNode(true));
   const thumbTemplate=thumbs.querySelector('li[data-target]')?.cloneNode(true);
   if(!templates.length||!thumbTemplate)continue;
   const nativeActivate=gallery.setActiveMedia.bind(gallery);
   gallery.elements.viewer.addEventListener('slideChanged',event=>{
    const active=event.detail.currentElement;
    if(!active||!viewer.contains(active))return;
    for(const item of viewer.children)item.classList.toggle('is-active',item===active);
   });
   const section=gallery.id.replace('MediaGallery-','').replace(/-duplicate$/,'');
   let currentId;
   function rebuild(variant){
    const lang=variant.lang;const original=config.books[lang];if(!original)return;
    const files=original.map((file,index)=>index===0&&lang==='fr'&&conceptFile?conceptFile:file);
    gallery.dataset.diyConcept=lang==='fr'&&conceptFile?String(concept):'current';
    const rawId=String(variant.mediaId||config.variants.find(v=>v.mediaId)?.mediaId);
    const template=templates.find(el=>el.dataset.mediaId.endsWith('-'+rawId))||templates[0];
    const oldId=template.dataset.mediaId.substring(section.length+1);
    viewer.replaceChildren();thumbs.replaceChildren();
    if(modal&&modalTemplate)modal.replaceChildren();
    files.forEach((file,index)=>{
     const id=index===0?rawId:rawId+'-diy-'+(index+1),fullId=section+'-'+id;
     const item=template.cloneNode(true);replaceIds(item,oldId,id);
     item.dataset.mediaId=fullId;item.classList.remove('product__media-item--variant','product__media-item--single');
     item.classList.toggle('is-active',index===0);paint(item,file);viewer.append(item);
     const thumb=thumbTemplate.cloneNode(true);const thumbOld=thumb.dataset.target.substring(section.length+1);replaceIds(thumb,thumbOld,id);
     thumb.dataset.target=fullId;thumb.dataset.mediaPosition=String(index+1);thumb.classList.remove('thumbnail-list_item--variant');
     const button=thumb.querySelector('button');button.setAttribute('aria-label',file.alt);
     button.removeAttribute('aria-current');if(index===0)button.setAttribute('aria-current','true');
     button.addEventListener('click',()=>gallery.setActiveMedia(fullId,false));paint(thumb,file);thumbs.append(thumb);
     if(modal&&modalTemplate){const image=modalTemplate.cloneNode(true);image.dataset.mediaId=id;image.classList.remove('product__media-item--variant');paint(image,file);modal.append(image);}
    });
    currentId=rawId;gallery.dataset.diyLanguage=lang;
    viewer.scrollLeft=0;thumbs.scrollLeft=0;
    gallery.elements.viewer.resetPages?.();gallery.elements.thumbnails.resetPages?.();
   }
   gallery.setActiveMedia=(target,prepend)=>{
    const variant=config.variants.find(v=>v.mediaId&&target.endsWith('-'+v.mediaId));
    if(variant&&String(variant.mediaId)!==currentId)rebuild(variant);
    return nativeActivate(target,prepend);
   };
   const selected=config.variants.find(v=>v.id===config.selectedVariant)||config.variants[0];
   rebuild(selected);
   nativeActivate(section+'-'+currentId,false);
   // Some pack variants have no featured media, so Organic does not call
   // setActiveMedia when returning to them. Follow the selected variant too.
   document.addEventListener('change',event=>{
    const picker=event.target.closest?.('variant-radios,variant-selects');
    if(!picker)return;
    const variant=config.variants.find(v=>v.id===picker.currentVariant?.id);
    if(variant&&(String(variant.mediaId)!==currentId||gallery.dataset.diyLanguage!==variant.lang)){
     rebuild(variant);nativeActivate(section+'-'+currentId,false);
    }
   });
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init().catch(e=>console.error('DIY gallery:',e)),{once:true});
 else init().catch(e=>console.error('DIY gallery:',e));
})();
